import React from "react"

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
const AuthUserContext = React.createContext()

export const AuthUserProvider = AuthUserContext.Provider
export const AuthUserConsumer = AuthUserContext.Consumer

export default AuthUserContext
